import { SafeError, SafePromise } from '@benzinga/safe-await';
import { ExtendedSubscribable } from '@benzinga/subscribable';
import { Session } from '@benzinga/session';

import { GetReportResponse, GetReportDataResponse, SupportedTickers } from './entities';
import { StockReportsRestful, StockReportsTickersRestful } from './restful';
import { ingestSupportedTickers } from './ingress';

interface ErrorEvent {
  error: SafeError;
  errorType: 'send_report_error' | 'get_suppprted_tickers_error';
  type: 'error';
}

interface GetStockReportsEvent {
  supportedTickers: SupportedTickers;
  type: 'send_report' | 'get_suppprted_tickers';
}

export type StockReportsRestfulEvent = ErrorEvent | GetStockReportsEvent;

interface StockReportsFunctions {
  getReport: StockReportsRequest['getReport'];
  getSupportedTickers: StockReportsRequest['getSupportedTickers'];
}

export class StockReportsRequest extends ExtendedSubscribable<StockReportsRestfulEvent, StockReportsFunctions> {
  private stockReportsRestful: StockReportsRestful;
  private stockReportsTickersRestful: StockReportsTickersRestful;

  constructor(session: Session) {
    super();
    this.stockReportsRestful = new StockReportsRestful(session);
    this.stockReportsTickersRestful = new StockReportsTickersRestful(session);
  }

  public getReport = async (ticker: string, email: string): SafePromise<GetReportResponse> => {
    const response = await this.stockReportsRestful.getReport(ticker, email);
    if (response.err) {
      this.dispatch({
        error: response.err,
        errorType: 'send_report_error',
        type: 'error',
      });
      return response;
    } else {
      return response;
    }
  };

  public getReportData = async (ticker: string): SafePromise<GetReportDataResponse> => {
    const response = await this.stockReportsRestful.getReportData(ticker);
    if (response.err) {
      this.dispatch({
        error: response.err,
        errorType: 'send_report_error',
        type: 'error',
      });
      return response;
    } else {
      return response;
    }
  };

  public getSupportedTickers = async (): SafePromise<SupportedTickers> => {
    const response = await ingestSupportedTickers(this.stockReportsTickersRestful.getSupportedTickers());
    if (response.err) {
      this.dispatch({
        error: response.err,
        errorType: 'get_suppprted_tickers_error',
        type: 'error',
      });
    } else {
      this.dispatch({
        supportedTickers: response.ok,
        type: 'get_suppprted_tickers',
      });
    }
    return response;
  };

  public onSubscribe = (): StockReportsFunctions => ({
    getReport: this.getReport,
    getSupportedTickers: this.getSupportedTickers,
  });
}
